import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _dec, _class, _class2, _temp;

import React from 'react';
import PropTypes from 'prop-types';
import { locale } from "../../../lib/locale/decorators";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { SpinnerIcon } from "../../../internal/icons/SpinnerIcon";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { rootNode } from "../../../lib/rootNode";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { ReactUIFeatureFlagsContext, getFullReactUIFlagsContext } from "../../../lib/featureFlagsContext";
import { styles } from "../Spinner.styles";
import { SpinnerLocaleHelper } from "../locale";
var types = ['big', 'mini', 'normal'];
export var SpinnerDataTids = {
  root: 'Spinner__root'
};
export
/**
* Используйте компонент `Spinner`, если вам нужен спиннер, без дополнительного функционала, который предоставляет компонент [Loader](https://tech.skbkontur.ru/react-ui/#/Components/Loader)
*/
var Spinner = (_dec = locale('Spinner', SpinnerLocaleHelper), rootNode(_class = _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Spinner, _React$Component);

  function Spinner() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.getProps = createPropsGetter(Spinner.defaultProps);

    _this.renderSpinner = function (type, dimmed, inline) {
      var _cx;

      return /*#__PURE__*/React.createElement(SpinnerIcon, {
        size: type,
        className: cx((_cx = {}, _cx[styles.circle(_this.theme)] = !dimmed && !_this.props.color, _cx[styles.circleDimmedColor(_this.theme)] = dimmed, _cx[styles.circleWithoutColorAnimation()] = dimmed || !!_this.props.color, _cx)),
        dimmed: dimmed,
        width: _this.props.width,
        color: _this.props.color,
        inline: inline
      });
    };

    _this.renderCaption = function (type, caption) {
      return /*#__PURE__*/React.createElement("span", {
        className: cx(styles[type](_this.theme), styles.captionColor(_this.theme))
      }, caption);
    };

    return _this;
  }

  var _proto = Spinner.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ReactUIFeatureFlagsContext.Consumer, null, function (flags) {
      _this2.featureFlags = getFullReactUIFlagsContext(flags);
      return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
        _this2.theme = theme;
        return _this2.renderMain();
      });
    });
  };

  _proto.renderMain = function renderMain() {
    var canDefaultCaptionBeRemoved = this.featureFlags.spinnerLoaderRemoveDefaultCaption;
    var defaultCaption = canDefaultCaptionBeRemoved ? null : this.locale.loading;
    var _this$props = this.props,
        _this$props$caption = _this$props.caption,
        caption = _this$props$caption === void 0 ? defaultCaption : _this$props$caption,
        dimmed = _this$props.dimmed,
        inline = _this$props.inline;
    var type = this.getProps().type;
    return /*#__PURE__*/React.createElement(CommonWrapper, _extends({
      rootNodeRef: this.setRootNode
    }, this.props), /*#__PURE__*/React.createElement("div", {
      "data-tid": SpinnerDataTids.root,
      className: styles.spinner()
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.inner()
    }, this.renderSpinner(type, dimmed, inline)), caption && this.renderCaption(type, caption)));
  };

  return Spinner;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'Spinner', _class2.displayName = 'Spinner', _class2.propTypes = {
  /**
  * Текст рядом с мини-лоадером.
  *
  * 'Загрузка' - значение по-умолчанию
  */
  caption: PropTypes.node,
  dimmed: PropTypes.bool,

  /**
  * Тип спиннера: mini, normal, big
  *
  * Значение по-умолчанию - normal
  *
  * Spinner.types - все доступные типы
  */
  type: PropTypes.oneOf(types)
}, _class2.defaultProps = {
  type: 'normal'
}, _class2.Types = Object.assign.apply(Object, [{}].concat(types.map(function (type) {
  var _ref;

  return _ref = {}, _ref[type] = type, _ref;
}))), _temp)) || _class) || _class);